/**
 * DateRangePicker modules
 */
export * from './daterangepicker';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-calendars/src/daterangepicker/index.js
// module id = 1908
// module chunks = 0